<template>
  <div class="row optionGroupPage">
    <div class="col-md-12">
      <div class="optionGroupToolbar">
        <b-button size="sm" variant="warning" @click="addAction()">+ option</b-button>
      </div>

      <List
        :__list="dataArray"
        :__isOnLoad="isListOnload"
        :__editMode="false"
        :__idxOnEdition="-1"
      ></List>
    </div>

    <transition name="optionGroupEditorOverlay">
      <div
        v-if="onEditionId !== null"
        class="optionGroupEditorBackdrop"
        @click="cancelAction"
      ></div>
    </transition>

    <transition name="optionGroupEditorDrawer">
      <div
        v-if="onEditionId !== null"
        class="optionGroupEditorDrawer"
        @click.stop
      >
        <div class="optionGroupEditorHead">
          <div>
            <div class="optionGroupEditorTitle">
              {{ onEditionIdx === -1 ? 'Nouvelle option' : 'Modifier option' }}
            </div>
            <div class="optionGroupEditorMeta">
              {{ onEditionItem && onEditionItem.name ? onEditionItem.name : 'Edition en cours' }}
            </div>
          </div>
          <button type="button" class="optionGroupEditorClose" @click="cancelAction">×</button>
        </div>

        <Edit
          :__item="onEditionItem"
          :__isOnLoad="isEditOnload"
        ></Edit>
      </div>
    </transition>
  </div>
</template>
<script>
import Edit from './Edit';
import List from './List';
export default {
  components: {
    Edit,
    List,
  },
  props: {
    modeAdmin:  {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      moduleRoute: '/grp_opts',
      onEditionId: null,
      onEditionIdx: -1,
      onEditionItem: null,
      isListOnload: false,
      isEditOnload: false,
      dataArray: [],
      onGoingReq:[],
    };
  },

  methods: {
    createEmptyItem() {
      return {
        name: '',
        needRoot: true,
        type: 'RADIO',
        useTitle: false,
      };
    },

    cancelAction() {
      this.onEditionId = null;
      this.onEditionIdx = -1;
      this.onEditionItem = null;
    },

    saveAction() {
      if (this.onEditionId === '__draft__') {
        this.createAction();
        return;
      }

      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.loadData(this.onEditionId, null, this.onEditionIdx);
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };
      let diff = this.__.differ(
        this.dataArray[this.onEditionIdx],
        this.onEditionItem
      );
      diff.push('_id');
      let data = this._.pick(this.onEditionItem, diff);
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    toggleActivateAction(id, val) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx].isActive = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', 'isActive']);
      data.isActive = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    editAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx)
      this.onEditionId = id;
      this.onEditionIdx = idx;
      this.onEditionItem = this._.omit(this.dataArray[idx]);
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    createAction() {
      this.onGoingReq.push({});
      const $onNext = (response) => {
        this.loadData(response.data, () => {
          this.editAction(response.data);
        });
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const data = this._.omit({ ...this.onEditionItem }, ['_id']);
      this.__.httpAction({
        methode: 'PUT',
        route: this.moduleRoute,
        data,
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    addAction() {
      this.onEditionId = '__draft__';
      this.onEditionIdx = -1;
      this.onEditionItem = this.createEmptyItem();
    },

    loadData(id = null, cb = null, putAt = null) {
      let $onNext = (response) => {
        if (id != null) {
          if (putAt != null) {
            this.dataArray[putAt] = response.data[0];
          } else {
            this.dataArray.push(response.data[0]);
          }

          if (cb) cb();
        } else {
          this.dataArray = response.data;
        }
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: this.moduleRoute+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    
  },
  mounted() {
    this.loadData();
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
  },
};
</script>
<style scoped>
.optionGroupPage {
  position: relative;
  min-height: calc(100vh - 119px);
  padding-top: 119px;
  padding-bottom: 20px;
}

.optionGroupToolbar {
  width: calc(100% + 30px);
  margin: 0 -15px 16px;
  padding: 8px 20px;
  background: #000;
}

.optionGroupToolbar .btn {
  min-width: 112px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 13px;
  text-transform: none;
}

.optionGroupEditorBackdrop {
  position: fixed;
  inset: 119px 0 0 0;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(3px);
  z-index: 1040;
}

.optionGroupEditorDrawer {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(720px, calc(100vw - 40px));
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  padding: 16px;
  background: #edf1f5;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  z-index: 1050;
}

.optionGroupEditorHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.optionGroupEditorTitle {
  color: #1f2a44;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.05;
}

.optionGroupEditorMeta {
  margin-top: 6px;
  color: #7b8aa5;
  font-size: 13px;
  font-weight: 600;
}

.optionGroupEditorClose {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 999px;
  background: #fff;
  color: #56627a;
  font-size: 24px;
  line-height: 1;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
}

.optionGroupEditorOverlay-enter-active,
.optionGroupEditorOverlay-leave-active {
  transition: opacity 0.24s ease;
}

.optionGroupEditorOverlay-enter,
.optionGroupEditorOverlay-leave-to {
  opacity: 0;
}

.optionGroupEditorDrawer-enter-active,
.optionGroupEditorDrawer-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}

.optionGroupEditorDrawer-enter,
.optionGroupEditorDrawer-leave-to {
  opacity: 0;
  transform: translate(-50%, calc(-50% + 24px));
}

@media (max-width: 767px) {
  .optionGroupToolbar {
    width: calc(100% + 24px);
    margin: 0 -12px 14px;
    padding: 8px 12px;
  }

  .optionGroupPage {
    padding: 119px 12px 12px;
  }

  .optionGroupEditorBackdrop {
    inset: 119px 0 0 0;
  }

  .optionGroupEditorDrawer {
    top: 119px;
    left: 0;
    right: 0;
    width: 100%;
    max-height: calc(100vh - 119px);
    transform: none;
    padding: 14px 12px 18px;
  }

  .optionGroupEditorTitle {
    font-size: 24px;
  }

  .optionGroupEditorDrawer-enter,
  .optionGroupEditorDrawer-leave-to {
    opacity: 0;
    transform: translateY(18px);
  }
}
</style>
<style></style>
